export default __webpack_public_path__ + "static/media/fontello.4438ea8b.ttf";